import { t } from 'state/intl/translations';

import { DrinksTabLink, DrinksTabLinkText, DrinksTabsWrapper } from './styled';
import { CATEGORY_LABEL_KEY, DrinkCategory } from './types';

interface ProductCustomizationDrinksTabsProps {
  categories: DrinkCategory[];
  activeTab: DrinkCategory;
  onTabPress: (tab: DrinkCategory) => void;
}

export const ProductCustomizationDrinksTabs = ({
  categories,
  activeTab,
  onTabPress,
}: ProductCustomizationDrinksTabsProps) => {
  return (
    <DrinksTabsWrapper testID="product-customization-drinks-tabs">
      {categories.map(category => (
        <DrinksTabLink
          key={`drinks-tab-${category}`}
          onPress={() => onTabPress(category)}
          minWidth={`${100 / categories.length}%`}
          active={activeTab === category}
        >
          <DrinksTabLinkText variant="headerThree" active={activeTab === category}>
            {t(CATEGORY_LABEL_KEY[category] as any)}
          </DrinksTabLinkText>
        </DrinksTabLink>
      ))}
    </DrinksTabsWrapper>
  );
};
